import { z } from "zod";

export const MarketSchema = z.object({
  display_name: z.string().min(3),
  fips_code: z.number(),
});

export const MarketsSchema = z
  .object({
    $schema: z.string().optional(),
  })
  .catchall(MarketSchema)
  .default({
    ok_okc: {
      display_name: "Oklahoma City-Norman, OK",
      fips_code: 11235,
    },
    ok_edmond: {
      display_name: "Oklahoma City, OK",
      fips_code: 36420,
    },
    tx_dallas: {
      display_name: "Dallas-Fort Worth-Arlington, TX",
      fips_code: 19100,
    },
    tx_houston: {
      display_name: "Houston-The Woodlands-Sugar Land, TX",
      fips_code: 26420,
    },
    tx_san_antonio: {
      display_name: "San Antonio-New Braunfels, TX",
      fips_code: 41700,
    },
    ks_mo: {
      display_name: "Kansas City, MO-KS",
      fips_code: 28140,
    },
    tx_austin: {
      display_name: "Austin-Round Rock-Georgetown, TX",
      fips_code: 12420,
    },
  });
